import { render } from "./ContributionPage.vue?vue&type=template&id=a41384d2&scoped=true"
import script from "./ContributionPage.vue?vue&type=script&lang=js"
export * from "./ContributionPage.vue?vue&type=script&lang=js"

import "./ContributionPage.vue?vue&type=style&index=0&id=a41384d2&scoped=true&lang=css"

import exportComponent from "/home/acartia-ops/acartia/src/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a41384d2"]])

export default __exports__